import { render, staticRenderFns } from "./SchoolCampaignJobSeekersResult.vue?vue&type=template&id=deee5a22&scoped=true&"
import script from "./SchoolCampaignJobSeekersResult.vue?vue&type=script&lang=js&"
export * from "./SchoolCampaignJobSeekersResult.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCampaignJobSeekersResult.vue?vue&type=style&index=0&id=deee5a22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deee5a22",
  null
  
)

export default component.exports